import BaseLayout from '@/layouts/baseLayout/BaseLayout'
import About from '@/views/about/About'
import Contact from '@/views/contact/Contact'
import GuestBook from '@/views/guestBook/GuestBook'
import History from '@/views/history/History'
import Home from '@/views/home/Home'
import GallerySelector from '@/views/imageGallery/GallerySelector'
import ImageGallery from '@/views/imageGallery/ImageGallery'
import VideoGallery from '@/views/imageGallery/VideoGallery'
import Links from '@/views/links/Links'
import Members from '@/views/members/Members'
import PlayWithUs from '@/views/playWithUs/PlayWithUs'
import UpcommingEvents from '@/views/upcommingEvents/UpcommingEvents'
import React from 'react'
import { Navigate, Route, Routes as Router } from 'react-router-dom'

const Routes: React.FC = () => {
  return (
    <Router>
      <Route path="/" element={<BaseLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/play-with-us" element={<PlayWithUs />} />
        <Route path="/upcomming-events" element={<UpcommingEvents />} />
        <Route path="/history" element={<History />} />
        <Route path="/gallery-selector" element={<GallerySelector />} />
        <Route path="/image-gallery" element={<ImageGallery />} />
        <Route path="/video-gallery" element={<VideoGallery />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/members" element={<Members />} />
        <Route path="/guest-book" element={<GuestBook />} />
        <Route path="/links" element={<Links />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Router>
  )
}

export default Routes
